import React from "react";
import BondPlayInfoModal from "./BondPlayInfoModal";
import { formatBondNumbersCoin, formatOddsMultiplier } from "../../utils/bondNumbersHelpers";

const DEFAULT_CONSTANTS = {
  minStake: 100,
  maxStake: 500_000,
  odds: 2,
  platformFeeRate: 0.05,
  pendingPlayTtlMs: 120_000,
};

const BondNumbersInfoModal = ({ open = false, onClose, constants = DEFAULT_CONSTANTS }) => {
  const minStake = constants?.minStake || DEFAULT_CONSTANTS.minStake;
  const maxStake = constants?.maxStake || DEFAULT_CONSTANTS.maxStake;
  const odds = constants?.odds || DEFAULT_CONSTANTS.odds;
  const platformFee = Math.round((constants?.platformFeeRate || 0.05) * 100);
  const playSeconds = Math.round(
    (constants?.pendingPlayTtlMs || DEFAULT_CONSTANTS.pendingPlayTtlMs) / 1000
  );

  return (
    <BondPlayInfoModal
      open={open}
      onClose={onClose}
      titleId="bplay-numbers-info-title"
      title="Bond Numbers"
      subtitle="Reserve a ticket, get 11 numbers, then call Higher or Lower than the reference."
      sections={[
        {
          title: "Reserve a ticket",
          items: [
            <>Stake {formatBondNumbersCoin(minStake)}–{formatBondNumbersCoin(maxStake)} COIN. The investor pool covers your max win.</>,
            <>You receive 11 numbers — the middle one is locked as your reference.</>,
          ],
        },
        {
          title: "Pick & reveal",
          items: [
            <>Call whether the reveal lands <strong>Higher</strong> or <strong>Lower</strong> than the reference.</>,
            <>One of the other 10 numbers is revealed — the reference never repeats.</>,
            <>Win at {formatOddsMultiplier(odds)} gross. Payouts come from the investor pool.</>,
          ],
        },
        {
          title: "Timer & payout",
          items: [
            <>After reserving, tap <strong>Reveal</strong> within {playSeconds} seconds or cancel for a refund.</>,
            <>Platform fee ({platformFee}%) applies to player profit on wins.</>,
          ],
        },
      ]}
    />
  );
};

export default BondNumbersInfoModal;
